// extracted by mini-css-extract-plugin
export default {"container":"TakeTop_container__bziQ5","icon":"TakeTop_icon__dDdnW"};